import * as React from "react";
import { Input } from "@neworbit/simpleui-input";

import { FileUpload } from "@teamprevent/common/fileUploads";
import { FileAnswer } from "@teamprevent/common/questionnaires/model";
import { Label } from "semantic-ui-react";

import { TaskModel } from "@teamprevent/common/task/taskActions/models";

import { acceptableExtensions } from "@teamprevent/common/acceptableExtensions";

interface Props {
    submit: (result: string, evidence: FileAnswer, task: TaskModel) => Promise<void>;
    task: TaskModel;
}

interface State {
    result: string;
    evidence?: FileAnswer;
    submitted?: boolean;
}

export class ImmunisationBloodTestResultForm extends React.Component<Props, State> {

    public state: State = { result: "" };

    public render = () => {
        return (
            <>
                <Input.Text label="Result" onChange={this.onResultChanged} />
                <FileUpload
                    label="Evidence"
                    // eslint-disable-next-line max-len
                    apiUrl={`/api/customer/${this.props.task.customer.id}/employeeRecord/${this.props.task.employeeRecord.id}/immunisationCase/bloodtestresultevidence`}
                    onFileChange={(blobId, fileName) => this.setState({ evidence: { blobId, fileName } })}
                    acceptExtensions={acceptableExtensions}
                />
                {this.state.submitted && !this.state.evidence && <Label basic pointing color="red" content="You must upload evidence" />}
            </>
        );
    };

    public submit = async () => {
        this.setState({ submitted: true });
        if (!this.state.evidence) {
            return false;
        }

        await this.props.submit(this.state.result, this.state.evidence, this.props.task);
        return true;
    };

    private onResultChanged = (result: string) => this.setState({ result });
}
